import React from "react";
import "../Css/LoginHeader.css";
import { Link } from "react-router-dom";
import logo from "../images/ref.png";

function LoginHeader() {
  return (
    <div className="loginheader">
      <Link className="link" to="/">
        <img src={logo} alt="worldCom" className="homeheaderlogo" />
      </Link>
    </div>
  );
}

export default LoginHeader;
